import { translate } from '@openclassrooms/translations';
import { ImageCdn } from '@openclassrooms/images-cdn';

import NewFeatureBanner from 'Modules/marketing/components/NewFeatureBanner';

import useBlueshiftLiveContent from '../../hooks/useBlueshiftLiveContent';
import { SlotNames } from '../../constants/blueshift';

const PredictiveCRMNewFeaturePromotion = () => {
  const { liveContent } = useBlueshiftLiveContent(SlotNames.NewFeature);

  if (!liveContent || !liveContent.content.firstButton) {
    return null;
  }

  const { content } = liveContent;
  const bullets = ['bullet_1', 'bullet_2', 'bullet_3']
    .map((bulletPropertyName) => content[bulletPropertyName])
    .filter(Boolean) as string[];

  const firstButtonEvent = content.firstButton.dataEvent;
  const secondButtonEvent = content?.secondButton?.dataEvent;

  const firstButtonDataEvent = `${firstButtonEvent.type}::${firstButtonEvent.category}::${firstButtonEvent.action}::${firstButtonEvent.label}`;
  const secondButtonDataEvent =
    content.secondButton && secondButtonEvent
      ? `${secondButtonEvent.type}::${secondButtonEvent.category}::${secondButtonEvent.action}::${secondButtonEvent.label}`
      : null;

  return (
    <NewFeatureBanner
      userId={content.userId ?? 'anonymous'}
      storageKey={content.storageKey}
      title={content.title}
      subheading={content.subheading}
      bullets={bullets}
      firstButtonProps={{
        children: content.firstButton.label,
        href: content.firstButton.url,
        'data-event': firstButtonDataEvent,
        target: content.firstButton.isTargetBlank ? '_blank' : undefined,
      }}
      secondButtonProps={
        content.secondButton && {
          children: content.secondButton.label,
          href: content.secondButton.url,
          'data-event': secondButtonDataEvent,
          target: content.secondButton.isTargetBlank ? '_blank' : undefined,
        }
      }
      media={content.mediaUrl && <ImageCdn src={content.mediaUrl ?? null} alt="" />}
      translations={{
        closeButtonLabel: translate('global.action.close_button'),
      }}
    />
  );
};

export default PredictiveCRMNewFeaturePromotion;
